import { isVisible } from "utils/is_visible"

export function anyVisible(elements) {
  if (typeof elements === "string") {
    elements = document.querySelectorAll(elements)
  }
  return Array.from(elements).some((element) => {
    return isVisible(element)
  })
}
